import * as React from 'react'
import styled, { keyframes } from 'styled-components'
import Slider from 'react-slick'
import { BLUE, GRAY_DARK, WHITE, GRAY, RED, GRAY_LIGHTEST, GRAY_LIGHT } from '../../theme/colors'
import transparentGrid from '../../assets/transparent_grid.png'
import Icon from 'antd/lib/icon'
import Input from 'antd/lib/input'
import Select from 'antd/lib/select'
import Checkbox from 'antd/lib/checkbox'
import Button from 'antd/lib/button'
import Popover from 'antd/lib/popover'
import Tag from 'antd/lib/tag'
import AutoComplete from 'antd/lib/auto-complete'
import Pagination from 'antd/lib/pagination'
import { PREDYED_TRANSPARENT } from '../../constants'
import { AVENIR_MEDIUM } from '../../theme/fonts'

const MyPopover = ({ className, ...props }) => <Popover {...props} overlayClassName={className} />

interface ColorProps {
  color?: string
  selected?: boolean
}

interface StyledProps {
  collapsed?: boolean
  showMenu?: boolean
  fullWidth?: boolean
  secondary?: boolean
  isActive?: boolean
  isScrolled?: boolean
  show?: boolean
}

export const Container = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  display: flex;
  align-items: flex-start;
`

export const MainTitle = styled.div`  
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-family: Avenir;
  font-size: 18px;  
  margin: 20px 0;
  text-align: center;
`

export const SideBar = styled.div`
  width: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? '0' : '400px')};
  display: flex;
  flex-direction: column;
  padding: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? '0' : '12px 14px 0 14px')};
  align-items: center;
  position: relative;
  height: 100%;
  box-shadow: 2px 1px 4px -1px #c7c7c7;
  justify-content: flex-start;
  background-color: #ffffff;
  z-index: 1;
  transition: 0.35s;
`

export const CollapseButtonContainer = styled.div`
  position: absolute;
  right: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? '-150px;' : '-61px')};
  top: calc(100vh / 2 - 80.82px);
  z-index: 10;
  transition: 0.35s;
`

export const CollapseButton = styled.div`
  text-align: center;
  color: ${WHITE};
  background: #313131;
  width: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? '252px;' : '94px')};
  font-weight: 600;
  padding: 4px 11px;
  padding-top: 6px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  transform: rotate(-90deg);
  cursor: pointer;
  box-shadow: 0px 0px 0px 1px rgba(192, 192, 192, 0.2);
`

export const FlexCollapseButton = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const CollapseButtonIcon = styled(Icon)`
  color: #6a6a6a;
  font-size: 15px;
`

export const CollapseButtonContent = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`

export const ColorPaletteSectionContainer = styled.div`
  display: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? 'none' : 'block')};
  overflow-y: scroll;
  position: relative;
`

export const StickyHeader = styled.div`
  position: sticky;
  top: 0;
  z-index: 3;
  background: ${WHITE};
  padding-bottom: 6px;
  box-shadow: ${({ isScrolled }: StyledProps) => (isScrolled ? '0px 1px 4px -1px #c7c7c7' : 'none')};
`

export const Title = styled.div`
  display: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? 'none' : 'flex')};
  flex-flow: column;
  justify-content: center;
  align-items: center;
  font-weight: bold;
  font-family: Avenir;
  font-size: 14px;  
  margin-bottom: 10px;
`

export const TabsContainer = styled.div`
  display: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? 'none' : 'block')};
  overflow-y: scroll;
  overflow: visible;
  position: relative;

  .ant-tabs-content {
    height: auto !important;
  }
  & .ant-tabs-nav-wrap {
    display: flex !important;
    justify-content: center !important;
    background-color: ${WHITE} !important;
    height: 47px !important;
  } 

  & .ant-tabs-ink-bar {
    background-color: ${GRAY} !important;
    bottom: 14px !important;
  }

  & .ant-tabs-nav .ant-tabs-tab {
    color: #739ac7 !important;
    margin: 10px 48px 0 18px !important;
  }

  & .ant-tabs-nav .ant-tabs-tab-active {
    color: #6d7a96 !important;
    font-weight: 600 !important;
  }
  .ant-tabs-nav-wrap {
    justify-content: flex-start !important;
    padding-left: 16px !important;
  }
  .ant-tabs-tab {
    transition: all .15s;
  }
  .ant-tabs-ink-bar {
    display: none !important;
  }

  ${({ showMenu }: { showMenu: boolean }) => showMenu ? `
    .ant-tabs-nav-container {
      border-bottom: 1px solid #DCDCDC;
    }
    .ant-tabs-nav .ant-tabs-tab-active {
      border: 1px solid #d1d1d1;
      margin-top: 10px !important;
      padding-top: 8px !important;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  ` : ''}
`

export const TabTitle = styled.div`
  font-size: 13px;
  letter-spacing: 0.2px;
`

export const Row = styled.ul`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding-left: 0;
  width: 100%;
`

export const RegularColorsContainer = styled.div`
  padding: 0 10px;
  margin-top: 12px;
`

export const ColumnRight = styled.div`
  width: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? '100%' : 'calc(100% - 400px)')};
`

export const ButtonsTopGroup  = styled.div`
  display: flex;
  width: 100%;
`

export const ColumnLeftContainer = styled.div`
  width: 100%;
`

export const FeaturedTitle = styled.div`
  font-weight: bold;
  font-size: 18px;
`

export const SliderStyled = styled(Slider)`
  width: 100%;
`

export const CollectionsGallery = styled.div`
  margin: 0 34px;
`

export const Filters = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
  margin-top: 20px;
  padding: 0 30px;
`

export const StyledPaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  padding-left: 165px;

  @media (max-width: 1024px) {
    padding-left: 0;
  }
`

export const StyledPagination = styled(Pagination)`
  font-size: 12px;
  font-family: ${AVENIR_MEDIUM};
  font-weight: 600;
  transition: all .40s;

  .ant-pagination-item {
    height: 30px !important;
    border: none !important;
    margin-right: 0 !important;
    background-color: white !important;
  }

  .ant-pagination-next {
    margin-left: 6px !important;
  }

  .ant-pagination-prev .ant-pagination-item-link {
    border: none !important;
    background-color: #f5f5f5 !important;
    border-radius: 9px !important;
  }

  .ant-pagination-next .ant-pagination-item-link {
    border: none !important;
    background-color: #f5f5f5 !important;
    border-radius: 9px !important;
  }

  .ant-pagination-next a {
    &:hover {
      color: #7682ff !important;
    }
    &:active {
      color: #7682ff !important;
    }
  }

  .ant-pagination-prev a {
    &:hover {
      color: #7682ff !important;
    }
    &:active {
      color: #7682ff !important;
    }
  }

  .ant-pagination-item a {
    color: rgb(130 130 130) !important;
    margin: 0 13px !important;
  }

  .ant-pagination-item-active a {
    color: white !important;
    background: #7682ff;
    padding: 12px 16px;
    border-radius: 10px;
    box-shadow: 0px 1px 7px #7682ff;
    font-weight: 600;
  }
`

export const DesignsCounter = styled.p`
  margin: 0;
  font-size: 16px;
  transition: all .25s;
  width: ${({ secondary }: StyledProps) => secondary ? '40%' : 'calc(40% - 106px)'};
`

export const FlexBox = styled.div`
  display: flex;
`

export const FiltersComponent = styled.div`
  display: flex;
  align-items: flex-start;
  flex: 1;
  margin-top: -22px;
  color: gray;

  @media (max-width: 767px) {
    display: none;
  }
`

const inAnimation = keyframes`
 0% { opacity: 0; visibility: hidden; }
 100% { opacity: 1; visibility: visible; }
`

export const ColorFiltersButton = styled.div`
  display: flex;
  color: ${BLUE};
  align-items: center;
  cursor: pointer;
  padding-bottom: 15px;
  background: white;
  padding: 4px 24px;
  padding-left: 18px;
  height: fit-content;
  border-radius: 50px;
  border-top: 1px solid #f1f1f1;
  box-shadow: 0px 1px 3px 0px lightgray;
  transition: all .25s;
  &:hover {
    opacity: 0.7;
  }
`

export const ColorFiltersButtonIcon = styled.div`
  margin-bottom: 6px;
  width: fit-content;
`

export const ColorFiltersButtonIconImg = styled.img`
  max-width: 18px;
  margin-right: 10px;
`

export const ColorFiltersButtonTitle = styled.span`
  color: #5f6062;
  font-size: 12px;
`

export const ColorFiltersCloseButton = styled.div`
  margin-left: 22px;
  cursor: pointer;
`

export const ColorFiltersCloseButtonImg = styled(Icon)`
  color: ${BLUE};
  font-size: 16px;
`

export const SelectColorListContainer = styled.div`
  align-items: center;
  padding-bottom: 15px;
  display: ${({ show }: StyledProps) => show ? 'flex' : 'none'};
  animation: ${inAnimation} 250ms ease-in;
  box-shadow: 0px 1px 3px 0px lightgray;
  border-top: 1px solid #f1f1f1;
  padding: 6px 22px;
  border-radius: 5px;
  @media (max-width: 1024px) {
    margin-left: 0;
  }
`

export const RightSection = styled.div`
  display: flex;
  align-items: center;
  @media (max-width: 1024px) {
    display: ${({ collapsed }: { collapsed?: boolean }) => (collapsed ? 'block' : 'none')};
  }

  @media (max-width: 767px) {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
`

export const ShowFavoritesButton = styled.div`
  margin-right: 10px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`

export const ShowFavoritesButtonIcon = styled(Icon)`
  margin-right: 5px;
  color: ${RED};
`

export const ClearButtonText = styled.div`
  color: ${BLUE}; 
  display: inline; 
  margin-left: 6px;
  margin-right: 6px;
  &:hover {
    cursor: pointer;
  }
`

export const BackToTopButton = styled.div`
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #797979b8;
  backdrop-filter: blur(2px);
  z-index: 3;
  color: ${WHITE};
  padding: 6px 10px;
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  box-shadow: 0px 2px 3px 0px darkgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
    background: #797979ed;
  }
`

export const MoreItemsFloating = styled.div`
  position: fixed;
  bottom: 320px;
  background: #797979b8;
  backdrop-filter: blur(2px);
  z-index: 3;
  right: 20px;
  color: ${WHITE};
  padding: 6px 10px;
  border-radius: 5px;
  display: flex;
  flex-flow: column;
  box-shadow: 0px 2px 3px 0px darkgray;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    transform: scale(1.03);
    background: #797979ed;
  }
  @media (max-width: 768px) {
    right: calc(50% - 37px);
    bottom: 58px;
  }
  animation: bounce2 1.25s ease 0.25s both;
  @keyframes bounce2 {
    0% {
      opacity: 0;
      transform: translateY(0);
    }
    10% {
      opacity: 1;
    }
    25% {
      transform: translateY(-15px);
    }
    30% {
      transform: translateY(0);
    }
    40% {
      transform: translateY(-7px);
    }
    50%, 100% {
      transform: translateY(0);
    }
    75% {
      transform: translateY(-15px);
    }
    80% {
      transform: translateY(0);
    }
    90% {
      transform: translateY(-7px);
    }
  }
`

export const DownArrow = styled(Icon)`
  background: #585858;
  border-radius: 25px;
  width: fit-content;
  color: #aaf6ff;
  padding: 4px;
  font-size: 12px;
  margin: 0 auto;
  margin-bottom: -14px;
  margin-top: 3px;
  box-shadow: 0px 2px 3px 0px darkgray;
`

export const ReactionsContainer = styled.div`
  display: flex;
  justify-content: ${({ secondary }: { secondary: boolean }) => secondary ? 'space-between' : 'flex-end'};
`

export const ReactionContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 12px;
  &:last-child {
    margin-right: 0px;
  }
`

export const ReactionIcon = styled(Icon)`
  color: ${({ secondary }: StyledProps) => secondary ? '#da6161' : '#4a91e2'};
  transition: hover .25s;

  &:hover {
    opacity: 0.7;
  }
`

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 5px;
`

export const DesignsListContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 18px;
`

export const StyledSelect = styled(Select)`
  width: 162px;
  transition: all .25s;
  & .ant-select-selection {
    border-radius: 25px;
    height: 28px;
    border: 1px solid #e9e9e9;
    background: #f8f8f8;
  }
  .ant-select-selection-selected-value {
    padding-right: 8px;
  }
  .ant-select-selection__rendered {
    line-height: 26px;
    font-size: 13px;
    margin-left: 12px;
    margin-right: 12px;
  }
  .ant-select-selection__placeholder {
    color: #a4a4a4;
  }
`

export const SliderStyledCollections = styled(Slider)`
  width: 100%;
`

export const CarouselFeatured = styled.div`
  display: flex;
  width: 100%;
  margin-top: 18px;
`

export const DesignPopover = styled(MyPopover)`
  .ant-popover-inner-content {
    padding: 4px 6px;
  }
  .ant-popover-arrow {
    display: none;
  }
  @media (max-width: 768px) {
    display: none;
  }
`

export const DesignThumbnail = styled.img`
  object-fit: cover;
  height: 400px;
  width: 360px;
  padding: 2px;
  background: ${GRAY_LIGHTEST};
  transition: all .25s;
  @media (max-width: 698px) {

  }
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const FeaturedDiv = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  max-width: 168px;
  min-width: 164px;
  min-height: 278px;
  background: linear-gradient(180deg, whitesmoke 70%, white 100%);
  border: 1px solid #e8e8e8;
  border-radius: 7px;
  margin: 0 auto;
  margin-bottom: 6px;
  padding: 2px;
  transition: all 0.25s;
  position: relative;
  &:hover {
    cursor: pointer;
    box-shadow: 1px 2px 6px -1px #dadada;
  }

  @media (min-width: 1440px) {
    min-width: 184px;
    max-width: 186px;
  }

  @media (max-width: 767px) {
    margin: 0;
    min-height: 268px;
  }
`

export const FeaturedThumbnail = styled.img`
  max-width: 190px;
  border-radius: 7px;
  object-fit: contain;
  padding: 0;

  @media (min-width: 1440px) {
    max-width: 220px;
  }
`

export const ThumbnailTrigger = styled.div`
  position: absolute;
  left: 20px;
  top: 20px;
  width: 148px;
  height: 186px;
  @media (max-width: 698px) {
    left: 10px;
    top: 4px;
    width: 148px;
    height: 168px;
  }
`

export const FooterFeatured = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;
  padding: 4px 6px;
  margin-top: 4px;
`

export const NameSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const DesignName = styled.div`
  font-size: 12.75px;
  color: #4665bc;
  &:hover {
    cursor: pointer;
    color: ${RED};
  }
`

export const LikesCounter = styled.div`
  color: #2773c9;
  font-size: 10px;
  text-align: center;
  width: 28px;
  margin-right: -6px;
`

export const HeartIcon = styled(Icon)`
  margin-left: 4px;
  font-size: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const SecondaryRow = styled.div`
  display: flex;
  justify-content: space-between;
`

export const CollectionName = styled.div`
  font-size: 12px;
  color: ${BLUE};
  margin-top: 4px;
  margin-bottom: 4px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const CollectionIcon = styled(Icon)`
  margin-right: 4px;
  color: ${GRAY};
`

export const StyleColors = styled.div`
  display: flex;
  justify-content: flex-start;
`

export const StyledTag = styled(Tag)`
  margin: 3px;
  cursor: pointer;

  &:hover {
    opacity: 0.7;
  }
`

export const StyleColor = styled.div`
  background: ${({ color }: ColorProps) => color }; 
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 1px solid #f0f0f0;
  margin-right: 3px;
`

export const ColorWithNameList = styled.div`
  display: flex;
  justify-content: center;
`

export const StyleColorWithNameContainer = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 12px;
  max-width: 68px;
  text-align: center;
  position: relative;
  &:hover {
    .circleHover {
      display: flex;
    }
    .colorName {
      color: ${BLUE};
    }
  }
`

export const CircleHover = styled.div`
  display: none;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 1px dashed ${({ color }: ColorProps) => color || 'black'};
  color: ${({ color }: ColorProps) => color || 'black'};
  top: 3px;
  position: absolute;
  align-items: center;
  justify-content: center;
`

export const StyleColorWithName = styled.div`
  background: ${({ color }: ColorProps) => color }; 
  width: 30px;
  height: 30px;
  border-radius: 50%;
  border: 1px solid #f0f0f0;
`

export const ColorName = styled.p`
  font-size: 10px;
  margin-top: 5px;
  margin-bottom: 0;
  color: #5f6062;
  transition: all .25s;
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #e3e3e3;
`

export const SearchSection = styled.div`
  margin-top: 35px;
  margin-bottom: 10px;
  width: 100%;
  display: flex;
  justify-content: center;
  position: relative;
`

export const PopOverFooter = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 698px) {
    align-items: flex-end;
  }
`

export const TooltipBody = styled.div`
  background: #f5fbff;
  margin: -12px -16px;
  padding: 12px 16px;
  border-radius: 10px;
  @media (max-width: 698px) {
    font-size: 12px;
  }
`

export const Tip = styled.p`
  font-style: italic;
  display: flex;
  align-items: center;
  @media (max-width: 698px) {
    display: flex;
    flex-wrap: wrap;
  }
`

export const TagMini = styled(Icon)`
  margin-left: 4px;
  margin-right: 6px;
  color: #6184c3;
`

export const PaletteDemo = styled.div`
  margin-left: 4px;
  margin-right: 6px;
  display: flex;
  border: 1px solid #dfdfdf;
  padding: 3px;
  border-radius: 3px;
  padding-right: 1px;
`

export const ColorDemo = styled.div`
  height: 6px;
  width: 6px;
  margin-right: 2px;
  border-radius: 25px;
  background: ${({ color }: ColorProps) => color || 'white'};
`

export const ClosePopoverButton = styled.div`
  cursor: pointer;
  color: red;
  @media (max-width: 698px) {
    height: fit-content;
    border: 1px solid red;
    padding: 2px 6px;
    border-radius: 3px;
  }
`

export const FilterBar = styled.div`
  background: #969696;
  height: 40px;
  margin-top: 30px;
  margin-bottom: -10px;
  display: flex;
  align-items: center;
  padding: 0 30px;

  @media (max-width: 767px) {
    height: 100%;
    flex-wrap: wrap;
  }
`

export const FilterBarTag = styled.div`
  font-size: 15px;
  display: flex;
  align-items: center;
  background: black;
  color: white;
  padding: 2px 10px;
  border-radius: 3px;
  margin-right: 10px;
  text-transform: ${({ secondary }: StyledProps) => secondary ? 'capitalize' : 'auto'};
  .anticon-close {
    color: white !important;
  }

  @media (max-width: 767px) {
    margin-block: 4px
  }
`

export const FilterBarTagTheme = styled.span`
  margin-right: 4px;
`

export const ColorIcon = styled.div`
  background: ${({ color }: ColorProps) => color || 'white'};
  height: 12px;
  width: 12px;
  border-radius: 25px;
  margin-right: 6px;
  margin-left: -2px;
`

export const CloseIcon = styled(Icon)`
  margin-left: 8px;
  font-size: 12px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    color: red;
  }
`

export const SearchIcon = styled(Icon).attrs({ type: 'search' })`
  color: #7591c0;
`

export const SearchContainer = styled.div`
  width: 74vw;
  max-width: 728px;
  position: relative;

  @media (max-width: 767px) {
    width: 100%;
    padding: 0 30px;
  }
  @media (max-width: 698px) {
    padding: 0 18px;
  }
`

export const SearchKeywordInput = styled(Input.Search)`
  &::placeholder {
    color: #a0b6cb;
  }
`

export const StyledMultiSelect = styled(AutoComplete)`
  width: 100%;
  border-radius: 25px;
  font-size: 16px;
  .ant-select-selection__placeholder {
    margin-left: 18px !important;
    color: gray;
    font-size: 14px;
  }
  @media (max-width: 698px) {
    .ant-select-selection__rendered {
      line-height: 33px;
    }
  }
`

export const SearchButton = styled.div`
  position: absolute;
  right: 4px;
  top: 4px;
  color: white;
  padding: 4px 12px;
  border-radius: 25px;
  font-size: 12px;
  z-index: 2;
  transition: all .25s;
  background: ${({ secondary }: StyledProps) => secondary ? '#769bdc' : '#dadada'};
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
  @media (max-width: 767px) {
    right: 34px;
  }
  @media (max-width: 698px) {
    right: 22px;
    top: 5px;
  }
`

export const ShareButton = styled.div`
  position: absolute;
  left: calc(100% + 62px);
  top: 4px;
  white-space: nowrap;
  padding: 2px 14px;
  padding-left: 10px;
  border-radius: 25px;
  font-size: 12px;
  color: cornflowerblue;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c2c2c261;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`

export const ShareIcon = styled.img`
  max-width: 14px;
  margin-right: 6px;
  filter: brightness(0.925);
`

export const OrDiv = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  margin-top: 22px;
  margin-bottom: 22px;
  font-weight: bold;
  font-family: Avenir;
  font-size: 14px;
  color: black;

  @media (max-width: 767px) {
    margin-block: 0 10px;
    font-weight: normal;
  }
`

export const UnSelectAllButton = styled.div`
  font-size: 12px;
  margin-left: 12px;
  letter-spacing: 0.1px;
  white-space: nowrap;
  top: 1px;
  padding: 4px 10px 4px 10px;
  color: white;
  border-radius: 7px;
  border: 1px solid white;
  transition: all .40s;
  &:hover {
    cursor: pointer;
    background: white;
    color: black;
  }

  @media (max-width: 767px) {
    margin: 4px 0;
    font-weight: normal;
  }
`

export const Descriptor = styled.div`
  display: inline;
  font-style: italic;
  font-size: 12px;
  color: ${({ color }: { color?: string }) => color};
`

export const OrLabel = styled.div`
  font-size: 16px;
`

export const CollectionDiv = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  max-width: 110px;
  margin: 0 auto;
  margin-bottom: 6px;
  cursor: pointer;
  transition: all .25s;
  position: relative;
  ${({ isActive }: { isActive?: boolean | null }) => isActive ? `
    border: 1px solid #83afff;
    border-radius: 5px;
    background: #f2f7ff;
    padding: 5px;
  ` : ''}
  &:hover {
    opacity: 0.8;
  }

  @media (max-width: 767px) {
    max-width: 74px;
  }
`

export const CloseButton = styled.div`
  position: absolute;
  top: 0px;
  right: -23px;
  padding: 0;
  cursor: pointer;
  background: #c1c1c1;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 20;
  font-size: 12px;
`

export const CollectionThumbnail = styled.img`
  max-width: 100%;
`

export const ThemeName = styled.div`
  margin-top: 12px;
  font-weight: bold;
  font-size: 15px;
  font-family: Avenir;
  display: flex;
  color: ${({ isActive }: { isActive?: boolean | null }) => isActive ? '#3a5d9d' : 'auto'};

  @media (max-width: 767px) {
    margin-top: 4px;
    font-size: 14px;
    align-items: center;
  }
`

export const SparklesIcon = styled.img`
  max-width: 18px;
  margin-right: 4px;
  margin-top: -4px;
  filter: ${({ isActive }: { isActive?: boolean | null }) => isActive ? 
    'invert(0.5) sepia(1) saturate(5) hue-rotate(181deg)' : 'unset'};
`

export const StyledButton = styled(Button)`
  height: 32px;
  border-radius: 4px;
  border: 0;
  width: ${({ fullWidth }: { fullWidth?: boolean }) => (fullWidth ? '100%' : 'none')};
  background: ${({ secondary }: { secondary?: boolean }) => (secondary ? '#918fff' : '#B68EFF')};
  margin: 4px;
  color: ${WHITE};
  transition: all .25s;
  &:hover {
    opacity: 0.7;
    cursor: pointer;
    background: ${({ secondary }: { secondary?: boolean }) => (secondary ? '#918fff' : '#B68EFF')};
    color: ${WHITE};
  }
  &:focus {
    background: ${({ secondary }: { secondary?: boolean }) => (secondary ? '#918fff' : '#B68EFF')};
    color: ${WHITE};
  }
`

export const Col = styled.li`
  display: inline-block;
  height: 32px;
  list-style: none;
  margin-bottom: 6px;
  text-align: center;
  width: calc(100% / 15);
  position: relative;
  @media (min-width: 768px) and (max-width: 991px) {
    width: 25%;
  }
`

export const Color = styled.div`
  background: ${({ color }: ColorProps) => color === PREDYED_TRANSPARENT ?
    `url(${transparentGrid})` : (color || WHITE)};
  border: 1px solid ${({ selected }: ColorProps) => (selected ? RED : '#b8b8b8')};
  cursor: pointer;
  width: 32.28px;
  height: 32.28px;
  border-radius: 6px;
`

export const CheckIcon = styled(Icon)`
  position: absolute;
  left: 22px;
  font-size: 12px;
  bottom: -2px;
  border-radius: 25px;
  color: white;
  background: #66b966;
`

export const BottomSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const ColorListTitle = styled.p`
  text-align: center;
  background: #eeeeee;
  margin-top: -12px;
  margin-left: -16px;
  margin-right: -16px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 3px 12px;
  font-size: 12px;
`

export const Loading = styled.div`
  display: flex;
  height: 70px;
  justify-content: center;
  align-items: center;
`

export const HintEnter = styled.div`
  position: absolute;
  top: 34px;
  left: 16px;
  color: #b1b1b1;
  font-size: 13px;
`

export const StyledInput = styled.input`
  border: 1px solid #a4b6b9 !important;
  padding: 5px 8px !important;
  padding-left: 18px !important;
  border-radius: 25px !important;
  box-shadow: 0px 2px 6px -2px #b4b4b4 !important;
  border-bottom: none;
  &:focus {
    border-color: cornflowerblue !important;
  }
`

export const ModalTitle = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0.25px;
  line-height: 27px;
`

export const InfoBody = styled.div`
  color: ${GRAY_DARK};
  font-family: Avenir;
  font-size: 16px;
  letter-spacing: 0.2px;
  line-height: 22px;
  margin: 12px 0 12px -38px;
`

export const buttonStyle = {
  background: BLUE,
  color: WHITE,
  border: 'none',
  boxShadow: 'none'
}

export const cancelButtonStyle = {
  background: WHITE,
  color: GRAY_DARK,
  borderColor: GRAY_LIGHT,
  boxShadow: 'none'
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/DesignCenterThemeGallery/styledComponents.tsx